module.exports = __webpack_public_path__ + "static/media/shaking_hands.531ba9f8.jpg";